import { useWhoami } from './use-whoami-query';

export const UNCONFIRMED_CLIENT_ROLE = 'unconfirmed-client';

export function useIsUnconfirmedClient() {
  const { data: whoamiData } = useWhoami({ params: {} });
  return whoamiData?.auth.roles.includes(UNCONFIRMED_CLIENT_ROLE);
}
